import Users from './Users'
import { connect } from 'react-redux'


const mapStateToProps = (state) => ({
    title: state.users.title,
})


export default connect(mapStateToProps)(Users)